import _              from 'lodash'
import React          from 'react'
import { withRouter } from 'react-router'

import { AuthMessage } from 'alto-react-base-auth/lib/components'

class ClientAuthMessage extends AuthMessage.WrappedComponent
  messages: ->
    _.assign {}, super(),
      profile_update_successful:
        <p>Váš profil byl úspěšně aktualizován.</p>
      pin_change_successful:
        <p>Váš PIN byl úspěšně změněn.</p>

export default withRouter(ClientAuthMessage)
